export const paymentStatusChoices = [
  { id: "pending", name: "resources.payments.statuses.pending" },
  { id: "paid", name: "resources.payments.statuses.paid" },
  { id: "overdue", name: "resources.payments.statuses.overdue" },
];

export const paymentDirectionChoices = [
  { id: "income", name: "resources.transactions.directions.income" },
  { id: "expense", name: "resources.transactions.directions.expense" },
];
